/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';

class UpArrows extends React.Component {
  render() {
    return (
      <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 284.929 284.929' width="20px" height="20px">
		    <g fill='#FFF'>
			    <path d='M17.128 167.872c1.903 1.902 4.093 2.854 6.567 2.854s4.664-.952 6.567-2.854L142.466 55.666l112.208 112.206c1.902 1.902 4.093 2.854 6.563 2.854 2.478 0 4.668-.952 6.57-2.854l14.274-14.277c1.902-1.902 2.847-4.093 2.847-6.563 0-2.475-.951-4.665-2.847-6.567L149.028 7.419c-1.901-1.906-4.088-2.853-6.562-2.853s-4.665.95-6.567 2.853L2.856 140.464C.95 142.367 0 144.554 0 147.034c0 2.468.953 4.658 2.856 6.561l14.272 14.277z'
			    />
			    <path d='M149.028 117.055c-1.901-1.906-4.088-2.856-6.562-2.856s-4.665.953-6.567 2.856L2.856 250.1C.95 252.003 0 254.192 0 256.67c0 2.472.953 4.661 2.856 6.564l14.272 14.276c1.903 1.903 4.093 2.848 6.567 2.848s4.664-.951 6.567-2.848l112.204-112.209L254.674 277.51c1.902 1.903 4.093 2.852 6.563 2.852 2.478 0 4.668-.948 6.57-2.852l14.274-14.276c1.902-1.903 2.847-4.093 2.847-6.564 0-2.478-.951-4.667-2.847-6.57L149.028 117.055z'
			    />
		    </g>
			</svg>
    );
  }
}

export default UpArrows;



// WEBPACK FOOTER //
// ./src/components/Footer/icons/UpArrows.js